import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const ACLearningContentTitle = ({
  type,
  lessonType,
  certification
}) => {
  switch (type) {
    case 'SHORT_FORM_CONTENT':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academyCommon.shortCard.label"
      });
    case 'LESSON':
      return lessonType ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: `academyCommon.resources.type.${lessonType}`
      }) : /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academyCommon.resources.type.LESSON"
      });
    case 'TRACK':
      return certification ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academyCommon.awards.BADGE_AND_CERTIFICATE"
      }) : /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academyCommon.resources.type.TRACK"
      });
    case 'PLAYLIST':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academyCommon.playlists.playlist"
      });
    case 'LEARNING_PATH':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academyCommon.playlists.hubspotPlaylist"
      });
    default:
      return undefined;
  }
};
export default ACLearningContentTitle;